export default "__VITE_ASSET__2bd2d47b__"